module.exports = __webpack_public_path__ + "static/media/logomin.6ae9e146.svg";